import {
  Box,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { FC } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Props {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  compactContent?: boolean;
  headerAction?: React.ReactNode;
}

export const CustomAccordion: FC<Props> = ({
  defaultExpanded = false,
  compactContent = false,
  title,
  children,
  headerAction,
}) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary
        tabIndex={-1}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="donor-info"
        id="donor-info"
        sx={
          compactContent
            ? {
                minHeight: 48,
                "&.Mui-expanded": {
                  minHeight: 48,
                },
                "& .MuiAccordionSummary-content": {
                  my: 1,
                },
                "& .MuiAccordionSummary-content.Mui-expanded": {
                  my: 1,
                },
              }
            : undefined
        }
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            pr: 1,
          }}
        >
          <Typography sx={{ color: `neutral.main` }} variant="subtitle1">
            {title}
          </Typography>
          {headerAction && (
            <Box
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
            >
              {headerAction}
            </Box>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={compactContent ? { pt: 0.5 } : undefined}>
        {children}

      </AccordionDetails>
    </Accordion>
  );
};
